import { Box, Flex, Heading } from '@radix-ui/themes';

function LittleRedHen() {
    return (
        <>
            <Box p="6">
                <Heading as="h3" size="8" weight="bold" mb="2" style={{ color: '#B42029' }}>
                    CHRISTMAS PREVIEW
                </Heading>
                <Flex direction={{ initial: 'column', xl: 'row' }} gap="4" wrap="nowrap" mt="4">
                    <Box style={{ aspectRatio: '541/700', maxHeight: 700, maxWidth: 541, overflow: 'hidden' }}>
                        <img
                            src={'/images/Stamp_Card_04.png'}
                            alt="Stamp Card 04"
                            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                        />
                    </Box>
                    <Flex wrap="wrap" justify="between" gap="4" pl={{ xl: '6' }} maxWidth="900px">
                        <Heading as="h4" size="8" weight="regular">
                            Christmas Preview (Chico, CA) stamp card and booth flier. Each piece of advertising utilizes pre-designed
                            elements from previous year events which I then arranged accordingly along with adding requested typographical
                            elements. Furthermore, upon completion to the client's satisfaction, vendor collaboration was utilized to
                            coordinate the print orders of each designed element.
                        </Heading>
                        <Box style={{ aspectRatio: '350/234', minWidth: 400, maxWidth: '49%', overflow: 'hidden' }}>
                            <img
                                src={'/images/Stamp_Card_03.png'}
                                alt="Stamp Card 03"
                                style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                            />
                        </Box>
                        <Box style={{ aspectRatio: '350/234', minWidth: 400, maxWidth: '49%', overflow: 'hidden' }}>
                            <img
                                src={'/images/Stamp_Card_02.png'}
                                alt="Stamp Card 02"
                                style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                            />
                        </Box>
                    </Flex>
                </Flex>
            </Box>
            <Box p="6">
                <Heading as="h3" size="8" weight="bold" mb="2" style={{ color: '#B42029' }}>
                    CHRISTMAS COLORS
                </Heading>
                <Flex direction={{ initial: 'column', xl: 'row' }} gap="4" wrap="nowrap" mt="4">
                    <Box style={{ aspectRatio: '700/700', maxHeight: 700, maxWidth: 700, overflow: 'hidden' }}>
                        <img
                            src={'/images/ChristmasColors.png'}
                            alt="Christmas Colors"
                            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                        />
                    </Box>
                    <Flex wrap="wrap" justify="between" gap="4" pl={{ xl: '6' }} maxWidth="800px">
                        <Heading as="h4" size="8" weight="regular">
                            Instagram advertisement showcasing the Little Red Hen Floral store's Christmas Colors product line of flowers.
                            Little Red Hen logo is the only pre-designed asset.
                        </Heading>
                        <Box style={{ aspectRatio: '500/333', maxWidth: '98%', overflow: 'hidden' }}>
                            <img
                                src={'/images/darkred_orig.png'}
                                alt="Dark Red Poinsettias"
                                style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                            />
                        </Box>
                        <Heading as="h4" size="8" weight="regular">
                            Photography of poinsettia flowers.
                        </Heading>
                    </Flex>
                </Flex>
            </Box>
        </>
    );
}

export default LittleRedHen;
